export const GET_HOME_BANNER_ATTEMPT = 'GET_HOME_BANNER_ATTEMPT';
export type GET_HOME_BANNER_ATTEMPT = typeof GET_HOME_BANNER_ATTEMPT;

export const GET_HOME_BANNER_SUCCESS = 'GET_HOME_BANNER_SUCCESS';
export type GET_HOME_BANNER_SUCCESS = typeof GET_HOME_BANNER_SUCCESS;

export const GET_HOME_BANNER_FAILURE = 'GET_HOME_BANNER_FAILURE';
export type GET_HOME_BANNER_FAILURE = typeof GET_HOME_BANNER_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/home-banner/get/Types.tsx